/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import ExpiredInsuranceContentTile from '../../../../common/components/ExpiredInsuranceContentTile/ExpiredInsuranceContentTile';
import { fonts, themes } from '../../../../common/themes/themes';
import CustomCard from '../../../../common/components/CustomCard';
import ExpiredInsuranceViewModalController from '../../../../common/Modals/Insurance/ExpiredInsuranceViewModal/ExpiredInsuranceViewModalController';
import Loader from '../../../../common/Lottifiers/Loader/Loader';

interface propsType {
  insurancesData: any;
  isLoading?: boolean;
  trans?: any;
}

const ExpiredInsurancePresenter: React.FC<propsType> = ({
  insurancesData,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [expiredInsuranceViewData, setExpiredInsuranceViewData] = useState({});

  return (
    <>
      <CustomCard
        cardSize={{ card_title: trans('Expired Insurance') }}
        cardHeight="330px"
        cardWidth="auto"
        showPadding={true}
        isHeightAuto={false}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {insurancesData?.length > 0 ? (
              _.map(insurancesData, (data: any) => {
                return (
                  <div key={data?.insurers?.name}>
                    <Box style={{ marginBottom: '15px' }} />
                    <ExpiredInsuranceContentTile
                      insuranceName={
                        data?.insurers?.name ? data?.insurers?.name : '--'
                      }
                      policyNumber={
                        data?.policy_number == 'undefined'
                          ? '--'
                          : data?.policy_number
                      }
                      startDate={data?.start_date}
                      expireDate={data?.expiry_date}
                      onClick={() => {
                        setOpenModal(true);
                        setExpiredInsuranceViewData(data);
                      }}
                    />
                  </div>
                );
              })
            ) : (
              <Grid
                container
                style={{ marginTop: '2em', marginBottom: '3.3em' }}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Insurance')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </CustomCard>

      {/* About Me Detail Modal */}

      {openModal && (
        <ExpiredInsuranceViewModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          expiredData={expiredInsuranceViewData}
          trans={trans}
        />
      )}
    </>
  );
};

export default ExpiredInsurancePresenter;
